
import React from 'react';
import { Link } from 'react-router-dom';
import { Shop } from '@/lib/supabase/shops/types';
import { Facebook, Instagram, Twitter, Linkedin, Youtube, ExternalLink } from 'lucide-react';

interface ShopFooterProps {
  shop: Shop | null;
  shopSlug?: string;
}

const ShopFooter = ({ shop, shopSlug }: ShopFooterProps) => {
  if (!shop) return null;

  return (
    <footer className="bg-gray-100 dark:bg-gray-900 border-t border-gray-200 dark:border-gray-800 mt-auto">
      <div className="container mx-auto py-8 px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Shop Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4">{shop.name}</h3>
            <p className="text-gray-600 dark:text-gray-400 mb-4">{shop.description}</p>
          </div>
          
          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Liens rapides</h3>
            <ul className="space-y-2">
              <li>
                <Link to={`/shop/${shopSlug}`} className="text-gray-600 dark:text-gray-400 hover:text-primary dark:hover:text-primary transition-colors">
                  Accueil
                </Link>
              </li>
              <li>
                <Link to={`/shop/${shopSlug}/categories`} className="text-gray-600 dark:text-gray-400 hover:text-primary dark:hover:text-primary transition-colors">
                  Catégories
                </Link>
              </li>
              <li>
                <Link to="#" className="text-gray-600 dark:text-gray-400 hover:text-primary dark:hover:text-primary transition-colors">
                  À propos
                </Link>
              </li>
              <li>
                <Link to="#" className="text-gray-600 dark:text-gray-400 hover:text-primary dark:hover:text-primary transition-colors">
                  Contact
                </Link>
              </li>
            </ul>
          </div>
          
          {/* Social Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Suivez-nous</h3>
            <div className="flex space-x-4">
              {shop.facebook_url && (
                <a href={shop.facebook_url} className="text-gray-600 dark:text-gray-400 hover:text-primary dark:hover:text-primary transition-colors">
                  <Facebook size={20} />
                </a>
              )}
              {shop.instagram_url && (
                <a href={shop.instagram_url} className="text-gray-600 dark:text-gray-400 hover:text-primary dark:hover:text-primary transition-colors">
                  <Instagram size={20} />
                </a>
              )}
              {shop.tiktok_url && (
                <a href={shop.tiktok_url} className="text-gray-600 dark:text-gray-400 hover:text-primary dark:hover:text-primary transition-colors">
                  <Twitter size={20} />
                </a>
              )}
            </div>
          </div>
        </div>
        
        <div className="mt-8 pt-6 border-t border-gray-200 dark:border-gray-800 text-center text-sm text-gray-500 dark:text-gray-500">
          <p>&copy; {new Date().getFullYear()} {shop.name}. Tous droits réservés.</p>
          <p className="mt-1">
            Propulsé par <a href="/" className="text-primary hover:underline">Scaloo</a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default ShopFooter;
